const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: 40,
    position: 'relative',
  },

  closeButton: {
    position: 'absolute',
    top: 16,
    right: 16,
    background: 'transparent',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#707087',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    borderRadius: '4px',
    transition: 'background-color 0.2s ease',
  },

  title: {
    color: '#000',
    fontFamily: 'Proxima Nova',
    fontSize: '28px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '150%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  subtitle: {
    color: '#707087',
    fontFamily: 'Proxima Nova',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '10px',
  },

  contentArea: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: 16,
    borderRadius: 8,
    border: '1px solid #E2E2FC',
    minHeight: 100,
  },

  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: '20px',
  },

  button: {
    width: '100px',
    height: '36px',
  },

  contentTitle: {
    color: '#546B81',
    fontFamily: 'Proxima Nova',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%',
    letterSpacing: '-0.176px',
  },

  inputContainer: {
    width: '48%',
  },
  datePickerContainer: {
    width: '48%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  containerGap: { gap: '10px' },

  select: {
    height: '46px',
    fontFamily: 'Proxima Nova',
    fontSize: '14px',
    border: '1px solid #E2E2FC',
    borderRadius: '8px',
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
    '&:focus': {
      backgroundColor: 'transparent !important',
    },
    '&:active': {
      backgroundColor: 'transparent !important',
    },
    '&.Mui-focused': {
      backgroundColor: 'transparent !important',
    },
    '&.Mui-disabled': {
      backgroundColor: 'transparent !important',
    },
    '& .MuiInputBase-root': {
      backgroundColor: 'transparent !important',
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
      '&:focus': {
        backgroundColor: 'transparent !important',
      },
      '&.Mui-focused': {
        backgroundColor: 'transparent !important',
      },
    },
    '& .MuiSelect-select': {
      backgroundColor: 'transparent !important',
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
      '&:focus': {
        backgroundColor: 'transparent !important',
      },
    },
    '& .MuiInputLabel-root': {
      fontSize: 14,
      lineHeight: '18px',
      fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
      display: 'flex',
    },
    '& .MuiInput-underline:before': {
      display: 'none',
    },
    '& .MuiInput-underline:after': {
      display: 'none',
    },
  },
  inputTitle: {
    color: '#707087',
    fontFamily: 'Proxima Nova',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px',
  },
  checkplatesContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
  },
  needsPermitLabel: {
    fontSize: 14,
    fontWeight: 400,
    color: '#707087',
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
  },
  dropdownContainer: { display: 'flex', flexDirection: 'column', gap: '10px' },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  headerSchedulingContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  blockContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  inputRoot: {
    padding: '0px 14px',
    '& .MuiInputBase-root': {
      backgroundColor: 'transparent !important',
    },
  },
  baseInformationHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
}

export default styles
